module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_50.de1182ed.gif";